import axios from 'axios';
import { formTypeFile, formTypeSelect, formTypeSelectMasterSlave } from './form.js';
import { Modal } from './modal.js';

export const formulaires = {
	gtagEvent: '',

	init() {
		if (document.querySelector('.formulaire')) {
			// INIT DES FORMULAIRES DU TYPE SELECT EN CUSTOM
			document.querySelectorAll('.type-select').forEach((form) => {
				new formTypeSelect(form);
			});

			// INIT DES FORMULAIRES DU TYPE SELECT MASTER / SLAVE EN CUSTOM
			document.querySelectorAll('.type-select-master-slave').forEach((form) => {
				// console.log("master / slave")
				new formTypeSelectMasterSlave(form);
			});

			// INIT DES FORMULAIRES DE TYPE FILE CUSTOM
			document.querySelectorAll('.type-file').forEach((form) => {
				new formTypeFile(form);
			});

			// FORMULAIRE DE TYPE CONTACT
			if (document.querySelector('#contact')) {
				document.querySelector('#contact .formulaire__submit').addEventListener('click', (e) => {
					e.preventDefault();

					// RESET LE STYLE ERREUR ET LA MODALE SI EXISTE
					this.resetAll();

					//  COLLECT LES DONNÉES À ENVOYER
					let dataToSend = this.collectDatas();

					// ENVOI À L'API CONTACT, SI ERREUR MET EN AVANT LES CHAMPS POSANT PROBLÈME + CRÉER UNE MODAL
					this.sendContactDatas(dataToSend);
				});
				// INIT LE NOM DU GTAG EVENT
				this.gtagEvent = 'submitContact';
			}

			// FORMULAIRE DE TYPE CANDIDATURE
			if (document.querySelector('#candidature')) {
				// console.log('candidature');
				document.querySelector('#candidature .formulaire__submit').addEventListener('click', (e) => {
					e.preventDefault();

					// RESET LE STYLE ERREUR ET LA MODALE SI EXISTE
					this.resetAll();

					//  COLLECT LES DONNÉES À ENVOYER
					let dataToSend = this.collectDatas();
					// console.log("dataTOSEnd" + dataToSend)
					let dataForm = new FormData();

					Object.keys(dataToSend).forEach((key) => {
						dataForm.append(key, dataToSend[key]);
					});

					// ENVOI À L'API CONTACT, SI ERREUR MET EN AVANT LES CHAMPS POSANT PROBLÈME + CRÉER UNE MODAL
					this.sendCandidatureDatas(dataForm);
				});

				// INIT LE NOM DU GTAG EVENT
				this.gtagEvent = 'submitCandidature';
			}

			// AU CLIC SUR LES FORM ON LE RESET
			document.querySelectorAll('.formulaire input, .formulaire textarea').forEach( input => {
				this.resetForm(input);
			})
		}
	},

	collectDatas() {
		let inputs = document.querySelectorAll('.formulaire__inputs');
		let dataCollect = {};

		inputs.forEach((input) => {
			if (input.closest('.type-radio')) {
				let inputRadio = input.querySelectorAll('input');
				inputRadio.forEach((input) => {
					if (input.checked) {
						dataCollect[input.name] = input.value;
					}
				});
			} else if (input.closest('.type-checkboxes')) {
				let inputCheckboxes = input.querySelector('input');
				dataCollect[inputCheckboxes.name] = inputCheckboxes.value;
			} else if (input.closest('.type-text')) {
				let inputText = input.querySelector('input');
				dataCollect[inputText.name] = inputText.value;
			} else if (input.closest('.type-select') || input.closest('.type-select-master-slave')) {
				input.querySelectorAll('input').forEach((input) => {
					if (input.checked) {
						dataCollect[input.name] = input.value;
					}
				});
			} else if (input.closest('.type-textarea')) {
				let inputTextArea = input.querySelector('textarea');
				dataCollect[inputTextArea.name] = inputTextArea.value;
			} else if (input.closest('.type-file')) {
				let inputTypeText = input.querySelector('input');
				dataCollect[inputTypeText.name] = inputTypeText.files[0];
			} else if (input.closest('.type-recaptcha')) {
				dataCollect['g-recaptcha-response'] = grecaptcha.getResponse();
			} else {
				// console.log('datas non recoltées', input);
			}
		});
		// console.log("collect:" + dataCollect.data);

		return dataCollect;
	},

	sendContactDatas(data) {
		axios({
			method: 'post',
			url: apiData.postContact,
			data
		})
			.then(function(reponse) {
				// ON TRAITE LA SUITE UNE FOIS LA RÉPONSE OBTENUE
				formulaires.formResponse(reponse);
			})
			.catch(function(erreur) {
				// ON TRAITE ICI LES ERREURS ÉVENTUELLEMENT SURVENUES
				console.log(erreur);
			});
	},

	sendCandidatureDatas(data) {
		axios
			.post(apiData.postCandidature, data, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			})
			.then(function(reponse) {
				//ON TRAITE LA SUITE UNE FOIS LA RÉPONSE OBTENUE
				formulaires.formResponse(reponse);
			})
			.catch(function(erreur) {
				// ON TRAITE ICI LES ERREURS ÉVENTUELLEMENT SURVENUES
				console.log(erreur);
			});
	},

	formResponse(reponse) {
		if (reponse.data.code === 'error_validation') {
			// SI ERREUR
			
			let errors = reponse.data.data.errors;

			// -- BOUCLE SUR LES ERREURS RENVOYÉES
			// -- APPLIQUER LE STYLE ERREUR
			Object.keys(errors).forEach((key) => {
				formulaires.addErrorClassToInputsFailed(key);
			});

			// -- CRÉATION DE LA MODALE AVEC LES ERREURS RENVOYÉES
			let modal = new Modal(errors, 'error');
			grecaptcha.reset();
		} else {
			// SI SUCCESS 
			
			// -- GTAG EVENT
			dataLayer.push({ event: this.gtagEvent });

			// -- AFFICHE MODAL DE SUCESS
			this.submitFormWithSucess();
			// -- RESET LE FORMULAIRE
			document.querySelector('form.form').reset();
			grecaptcha.reset();
			document.querySelector('.form').scrollTo();
			window.scrollTo(0,0);


		}
	},

	addErrorClassToInputsFailed(name) {
		let inputsFailed = document.querySelector(`input[name="${name}"], textarea[name="${name}"]`);
		inputsFailed.closest('.formulaire__inputs').classList.add('error');
	},

	resetAll() {
		// console.log("reset class error")
		if (document.querySelector('.error')) {
			document.querySelectorAll('.error').forEach((err) => {
				err.classList.remove('error');
			});
		}

		// DESTROY MODAL SI EXIST
		if (document.querySelector('.modal')) {
			document.querySelector('.modal').remove();
		}
	},

	resetForm(input){
		// AU PRESS
		input.addEventListener('keypress' , function(){
			if(this.closest('.error')) { 
				this.closest('.error').classList.remove('error')
			}
		})
		// AU CHANGEMENT 
		input.addEventListener('change' , function(){
			if(this.closest('.error')) { 
				this.closest('.error').classList.remove('error')
			}
		})

	}, 

	submitFormWithSucess(){

		// AFFICHE LE MESSAGE DE SUCESS DANS UNE MODAL
		const MESSAGE = '#message-form'

		if(document.querySelector(MESSAGE)){
			const message = document.querySelector(MESSAGE).dataset.message;
			new Modal({message}, 'sucess');
		}
		

	}
};
